import { useEffect, useState } from 'react';
import { hrApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { showApiError } from '@/utils/apiError';
import { KeyValueTable } from '@/components/ui/KeyValueTable';
import { notify } from '@/core/toast/notify';

export function HrSetupPage() {
  const [snapshot, setSnapshot] = useState<Record<string, unknown> | null>(null);  const [seeding, setSeeding] = useState(false);

  const load = () => {
    hrApi.getSetup().then(setSnapshot).catch((err) => showApiError(err, 'Failed to load HR setup'));
  };

  useEffect(() => {
    load();
  }, []);

  const seed = async () => {
    setSeeding(true);
    try {
      await hrApi.seedSetup();
      notify.success('Setup seeded successfully');
      load();
    } catch (err) {
      showApiError(err, 'Seed failed');
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div>
      <PageHeader
        title="HR Setup"
        description="Leave policies, shifts, approval workflows, and country payroll templates"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'HR', to: '/hr' }, { label: 'Setup' }]}
        actions={<Button onClick={seed} disabled={seeding}>{seeding ? 'Seeding…' : 'Seed defaults'}</Button>}
      />
      <div className="card p-6">
        {snapshot ? (
          <KeyValueTable data={snapshot} embedded emptyTitle="No setup data" />
        ) : (
          <p className="text-sm text-slate-500">Loading…</p>
        )}
      </div>
    </div>
  );
}
